module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.body),
      expression: "body"
    }],
    staticClass: "post"
  }, [_c('h4', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.issue.created_at, "MMM DD, YYYY")) + " By "), _c('a', {
    attrs: {
      "href": _vm.issue.user.html_url
    }
  }, [_vm._v(_vm._s(_vm.issue.user.login))])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.issue.title))]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.2@vue-loader/lib/template-compiler?{"id":"data-v-175afaf1"}!./~/.11.3.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Post.vue
// module id = 154
// module chunks = 1